import { useState, useCallback } from 'react';

type UseStitchImageOffsetParams = {
    highResolutionWidth: number;
    highResolutionHeight: number;
    previewWidth: number;
    previewHeight: number;
};

type UseStitchImageOffsetResult = {
    offset: number;
    dragBoundY: number;
    realPixelOffset: number;
    handleDragStop: (_e: unknown, data: { y: number }) => void;
    resetOffset: () => void;
};

export function useStitchImageOffset({
    highResolutionWidth,
    highResolutionHeight,
    previewWidth,
    previewHeight
}: UseStitchImageOffsetParams): UseStitchImageOffsetResult {
    const [offset, setOffset] = useState(0);

    const displayedHeight = highResolutionHeight / (highResolutionWidth / previewWidth);
    const dragBoundY = Math.max(0, displayedHeight - previewHeight);

    const ratio = highResolutionWidth / previewWidth;
    const realPixelOffset = offset * ratio * -1;

    const handleDragStop = useCallback((_e: unknown, data: { y: number }) => {
        setOffset(data.y);
    }, []);

    const resetOffset = useCallback(() => {
        setOffset(0);
    }, []);

    return {
        offset,
        dragBoundY,
        realPixelOffset,
        handleDragStop,
        resetOffset
    };
}
